<template>
  <b-button
    @click="
      () => {
        modalState = true;
      }
    "
    size="sm"
    :variant="httpRequestInProgress ? 'success' : 'primary'"
    :disabled="disabled"
    block
    ><!-- button -->
    {{ modalTitle }}
    <b-modal v-model="modalState" centered size="md" :title="modalTitle"
      ><!-- modal -->
      <div class="d-flex justify-content-end mb-3">
				<button
						type="button"
						class="btn btn-secondary table-secondary mr-3 my-0 py-0"
						size="sm"
						@click="
							synch.openMultipleTabs([
								'https://www.amazon.co.uk/gp/product/' + customerOrder.customerorderitems[0].stock.material.asin,
								'https://www.amazon.de/gp/product/' + customerOrder.customerorderitems[0].stock.material.asin,
								'https://www.amazon.fr/gp/product/' + customerOrder.customerorderitems[0].stock.material.asin,
							])
						"
				>
					<!-- button -->
					<span>Bei Amazon nachbestellen</span>
				</button>
			</div>

      <p>
        Diese Bestellung wirklich als Umbestellung markieren und neu bestellen?
      </p>
      <b class="p-2" v-if="lazyLoadingElements"
        >Passende Stocks werden gesucht...</b
      >
      <div class="d-flex justify-content-center">
        <b-overlay
          id="overlay-coi-change-vendor-stocks"
          :show="lazyLoadingElements || httpRequestInProgress"
          variant="light"
          opacity="0.5"
          blur="2px"
          rounded="lg"
          style="min-height: 200px"
        >
          <b-form-radio-group
            id="radio-group-2"
            name="radio-sub-component"
            v-model="selectedStock"
            :options="compiledStocks"
            stacked
          ></b-form-radio-group>
        </b-overlay>
      </div>

			<div v-if="customerOrder.customerorderitems[0].quantity > 1" class="mb-3">
				<label class="form-label">Menge</label>
				<b-input
						type="number"
						min="1"
						:max="customerOrder.customerorderitems[0].quantity"
						v-model="selectedQuantity"
				></b-input>
			</div>

			<div class="mb-3">
				<label class="form-label">Soll beim alten Lieferanten storniert werden?</label>
				<b-form-checkbox
						v-model="shouldCreateVendorCancellation"
						:value="true"
						:unchecked-value="false">
				</b-form-checkbox>
			</div>

			<div class="form-group w-50">
				<label for="comment">Kommentar</label>

				<b-form-input
						id="comment"
						v-model="comment"
				/>
			</div>


      <template #modal-footer>
	      <div class="w-100">
		      <b-button
				      class="float-right mx-1"
				      centered
				      size="md"
				      variant="primary"
				      :disabled="!selectedStock"
				      @click="changeVendor()"
		      >umbestellen</b-button
		      >
		      <b-button
				      class="float-right"
				      size="md"
				      variant="secondary"
				      @click="
            () => {
              modalState = false;
              selectedStock = null;
            }
          "
		      >abbrechen</b-button
		      >
	      </div>
      </template>
    </b-modal>
		<modal-error-component v-model="errorModal"></modal-error-component>
  </b-button>
</template>

<script>
import ModalErrorComponent from "../ModalErrorComponent.vue";


export default {
	components: {ModalErrorComponent},
  props: ["customerOrder", "orderStates", "authorization", "vendors"],
  data() {
    return {
      stocks: null,
      selectedQuantity: 1,
      selectedStock: null,
      modalState: false,
      httpRequestInProgress: false,
      lazyLoadingElements: false,
      shouldCreateVendorCancellation: false,
      comment: '',
			errorModal: {
				show: false,
				message: '',
				error: null,
				title: 'Fehler beim Laden der Geräte',
			}
    };
  },
  computed: {
    modalTitle: function () {
      if (this.authorization && this.authorization.dev)
        return "Umbestellung (VendorChange)";
      return "Umbestellung";
    },
    disabled: function () {
      return (
        this.orderStates.codes.OPEN !== this.customerOrder.orderState &&
        this.orderStates.codes.NEW !== this.customerOrder.orderState
      );
    },
    compiledStocks: {
      get: function (n, o) {
        if (!this.stocks) return [];
        let opts = this.stocks
          .map((stock) => {
            if (stock.vendorId == 10000) return null;
            stock.vendor = this.vendors.find((v) => v.id == stock.vendorId);
            stock.selected = false;
            let text = stock.vendor.name;
            text += `${1 === stock.articleCondition ? " (Neu" : " (SH"}`;
            //text += `, Eingangsporto: ${stock.vendorShippingFee}€, EK: ${stock.purchasePrice}€, Stock: ${stock.quantity}`;
            text += `, EK+EP: ${stock.totalCost}€, Stock: ${stock.quantity}`;
            if (21 == stock.vendorId)
              text += `, LZ:  ${stock.vendorDeliveryTime}`;
            text += `, LK:  ${stock.vendor.deliveryClass})`;
            return { value: stock.id, text };
          })
          .filter((id) => id);

        opts.push({ text: "Nachbestellung Amazon DE", value: -1 });
        opts.push({ text: "Nachbestellung Amazon FR", value: -2 });
        opts.push({ text: "Nachbestellung Amazon UK", value: -3 });
        opts.push({ text: "Nachbestellung Amazon Ebay", value: -4 });
        opts.push({ text: "Nachbestellung Amazon Sonstige", value: -5 });

        return opts;
      },
    },
  },
  watch: {
    modalState: function (n, o) {
      if (n && !o) this.lazyLoad();
    },
  },
  methods: {
    chooseStock(stock) {
      this.compiledStocks = this.compiledStocks.map((other) => {
        other.selected = other.id == stock.id;
        return other;
      });
    },
    lazyLoad() {
      this.httpRequestInProgress = true;
      this.lazyLoadingElements = true;
      Promise.all([
        axios.post(
          "/customerorder/action/changevendor/fetchalternativevendors",
          { customerOrder: this.customerOrder },
        ),
        new Promise((resolve) => setTimeout(resolve, 1200)),
      ])
        .then(([response]) => {
          this.stocks = response.data
            .map(function (stock) {
              stock.vendorShippingFee = parseFloat(stock.vendorShippingFee); //.toFixed(2);
              stock.purchasePrice = parseFloat(stock.purchasePrice); //.toFixed(2);
              stock.totalCost = stock.vendorShippingFee + stock.purchasePrice;
              console.log(`totalCost: ${stock.totalCost}`);
              stock.totalCost = `${stock.totalCost.toFixed(2)}`.replaceAll(
                ".",
                ",",
              );
              //stock.vendorShippingFee.replaceAll('.', ',');
              return stock;
            })
            .sort(function (v, w) {
              return (
                v.vendorShippingFee +
                v.purchasePrice -
                (w.vendorShippingFee + w.purchasePrice)
              );
            });
          this.httpRequestInProgress = false;
          this.lazyLoadingElements = false;
        })
        .catch((error) => {
          alert("Konnte potentielle Stocks nicht abrufen: Server-Fehler.");
          console.error(error);
        });
    },
    changeVendor() {
			this.httpRequestInProgress = true;
			console.log(`selectedStock: ${this.selectedStock}`);
      axios.post("/customerorder/action/changevendor", {
          customerOrderId: this.customerOrder.id,
          selectedStockId: this.selectedStock,
          selectedQuantity: this.selectedQuantity,
					shouldCreateVendorCancellation: this.shouldCreateVendorCancellation,
					comment: this.comment,
        }).then(response => {
					console.log(`response.data: ${response.data}`);
          this.httpRequestInProgress = false;
					//success bvtoast
				this.$bvToast.toast("Umbestellung erfolgreich!", {
						title: "Umbestellung",
						variant: "success",
						solid: true,
						autoHideDelay: 2000,
					});
					this.modalState = false;

          //either changevendor passes back a whole customerorder, or we need to still splice in the changed data.
				this.$emit("mutatedStock", response.data);
				this.$emit("success");
        }).catch(error => {
					this.httpRequestInProgress = false;
          console.error(error);
          this.errorModal = {
						show: true,
						message: "Fehler beim Umbestellen der Bestellung.",
						error:  error?.message ?? error,
						title: "Umbestellung fehlgeschlagen",
					};
        });
    },
  },
};
</script>
